export default __webpack_public_path__ + "static/media/8.cb23d30f.png";